import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  isLogin: null,
  csrfToken: null,
  expireTime: 0,
  email: null,
  pages: [],
  permissions: {},
  firstName: null,
  fullName: null,
};

const UserInfoSlicer = createSlice({
  name: "userInfo",
  initialState,
  reducers: {
    initUser: (state, action) => {
      const obj = action.payload;
      state.email = obj?.email || null;
      state.isLogin = obj?.isLogin || false;
      state.csrfToken = obj?.csrfToken || null;
      if (Array.isArray(obj?.pages)) state.pages = obj.pages;
      state.expireTime = obj?.expireTime || 0;
      state.permissions = obj?.permissions || {};
      state.firstName = obj?.firstName || null;
      state.fullName = obj?.fullName || null;
    },
    setIsLogin: (state, action) => {
      state.isLogin = action.payload;
    },
    setAccessPages: (state, action) => {
      const payload = action.payload;
      if (Array.isArray(payload)) state.pages = payload;
    },
    setCsrfToken: (state, action) => {
      state.csrfToken = action.payload;
    },
  },
});

export const { initUser, setCsrfToken, setAccessPages, setIsLogin } =
  UserInfoSlicer.actions;

export default UserInfoSlicer.reducer;
